import React from "react"
import ReactDOM from "react-dom"
import App from "./App"
import { AppBoundary } from "AppBoundary"
import "./index.css"
import "./colours.css"

ReactDOM.render(
  <React.StrictMode>
    <AppBoundary>
      <App />
    </AppBoundary>
  </React.StrictMode>,
  document.getElementById("root")
)
